import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').controller('UploaderController', UploaderController);

    /** @ngInject */
    function UploaderController(
        $scope,
        Upload,
        DocumentsService,
    ) {
        var vm = this;

        vm.isUploaded = true;

        vm.$onInit = function () {
            vm.fileList = [];
            vm.documents = [];
            vm.documentsTitles = [];

            if (vm.anexes) {
                vm.isAnexes = [];
            }

            if (vm.documentsBackend) {
                vm.documents = vm.documentsBackend;
            }
        };

        vm.$onChanges = function (changesObj) {
            if (
                changesObj.documentsBackend &&
                changesObj.documentsBackend.currentValue
            ) {
                if (changesObj.documentsBackend.currentValue.length) {
                    for (
                        var i = 0;
                        i < changesObj.documentsBackend.currentValue.length;
                        i++
                    ) {
                        vm.documents.push(
                            changesObj.documentsBackend.currentValue[i].id
                        );
                        vm.documentsTitles.push(
                            changesObj.documentsBackend.currentValue[i].title
                        );

                        if (vm.anexes) {
                            vm.isAnexes.push(
                                changesObj.documentsBackend.currentValue[i]
                                    .is_anex
                            );
                            vm.fileList.push({
                                id:
                                    changesObj.documentsBackend.currentValue[i]
                                        .id,
                                is_anex:
                                    changesObj.documentsBackend.currentValue[i]
                                        .is_anex,
                            });
                        } else {
                            vm.fileList.push(
                                changesObj.documentsBackend.currentValue[i].id
                            );
                        }
                    }
                }
            }
        };

        vm.uploadFiles = function (files) {
            if (files && files.length) {
                var endpoint;
                if (vm.isImage) {
                    endpoint = '/api/v1/images/';
                } else {
                    endpoint = '/api/v1/documents/';
                }

                for (var i = 0; i < files.length; i++) {
                    Upload.upload({
                        url: endpoint,
                        data: {
                            file: files[i],
                            title: files[i].name,
                        },
                    }).then(
                        function (response) {
                            vm.documents.push(response.data.id);
                            vm.documentsTitles.push(response.data.title);

                            /*
                             * create anexes or fill response (vm.fileList) with files id
                             */

                            if (vm.anexes) {
                                vm.isAnexes.push(false);
                                vm.fileList = vm.createResponseWithAnexes();
                            } else {
                                vm.fileList = vm.documents;
                            }

                            vm.isUploaded = true;
                        },
                        function () {},
                        function () {
                            vm.isUploaded = false;
                        }
                    );
                }
            }
        };

        vm.changeFileName = function (id, documentPosition) {
            if (vm.documentsTitles[documentPosition].length > 1) {
                DocumentsService.updateFileTitle(
                    id,
                    vm.documentsTitles[documentPosition]
                );
            }
        };

        vm.deleteFromArray = function (index, id) {
            DocumentsService.deleteFile(id);
            vm.documents.splice(index, 1);
            vm.documentsTitles.splice(index, 1);
        };

        vm.createResponseWithAnexes = function () {
            var docs = [];
            for (var i = 0; i < vm.documents.length; i++) {
                docs.push({ id: vm.documents[i], is_anex: vm.isAnexes[i] });
            }

            return docs;
        };

        vm.updateResponseWithAnexes = function (index) {
            vm.fileList[index].is_anex = vm.isAnexes[index];
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/uploader/uploader.controller.ts